import { AfterViewInit, Component, ElementRef, Input, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';

@Component({
  selector: 'app-switcher',
  templateUrl: './switcher.component.html',
  styleUrls: ['./switcher.component.scss']
})
export class SwitcherComponent implements AfterViewInit {

  @Input() id: string;
  @Input() name = '';
  @Input() class = '';
  @Input() color = false;
  @Input() label = '';
  @Input() tooltip = '';
  @Input() display = 'inline-block';
  /**
   * `v2`: o liga/desliga do layout novo (trilho verde com a bolinha, rótulo ao lado), como no
   * protótipo das Automações (09/10/2026). Opcional para as telas migrarem uma de cada vez; o
   * input nativo e os textos ON/OFF continuam no DOM (os specs Cypress clicam e leem por eles).
   */
  @Input() look: 'classic' | 'v2' = 'classic';
  @Output() checkedChange = new EventEmitter<boolean>();

  @ViewChild('switchCheckbox') switchCheckbox: ElementRef<HTMLInputElement>;

  private estado: boolean;

  /**
   * CU-86ak84mj6 — o clique do usuário marca ou desmarca o input NATIVO antes de
   * o Angular ver qualquer coisa. Quando a tela recusa a mudança e devolve o
   * valor anterior, o binding `[checked]` termina o ciclo com o mesmo valor de
   * antes, o Angular não reescreve o DOM, e o input fica desmarcado enquanto o
   * componente se considera ligado.
   *
   * O `*ngIf` do rótulo acompanhava o componente, mas o CSS desenha a bolinha a
   * partir de `input:checked` — o resultado era um switch pintado de desligado
   * ao lado do texto "Ativado".
   *
   * Escrever no input nativo a cada atribuição fecha essa diferença. Vale para
   * qualquer tela que rejeite a mudança, não só as de segundo fator.
   */
  @Input()
  set checked(valor: boolean) {
    this.estado = valor;
    this.syncNativeInput();
  }

  get checked(): boolean {
    return this.estado;
  }

  ngAfterViewInit(): void {
    this.syncNativeInput();
  }

  toggleChange(): void {
    this.checked = !this.checked;
    this.checkedChange.emit(this.checked);
  }

  private syncNativeInput(): void {
    if (this.switchCheckbox) {
      this.switchCheckbox.nativeElement.checked = !!this.estado;
    }
  }
}
